<template>
    <v-dialog v-model="deleteBundleDialog" max-width="700" persistent>
        <template v-slot:activator="{ on: dialog, attrs }">
            <slot name="dialogactivator" :on="dialog" :attrs="attrs">
                <v-tooltip right>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn v-bind="attrs" v-on="{ ...tooltip, ...dialog }" icon small text color="error">
                            <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Delete</span>
                </v-tooltip>
            </slot>
        </template>
        <v-card flat>
            <v-card-title class="flex-nowrap align-start">
                <span class="secondary--text">Delete {{ bundleTypeName }}</span>

                <v-spacer></v-spacer>
                <v-btn :disabled="deletingBundle" @click="deleteBundleDialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <div class="mt-3">
                    <v-alert type="info" prominent text>
                        Deleting a
                        <span>{{ bundleTypeNameLower }}</span>
                        does not remove the objects that have been distributed.
                    </v-alert>
                    <div class="mt-3">
                        Are you sure you want to delete
                        <span class="font-weight-bold">{{ bundleData.long_id }}</span>
                        ?
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <div class="d-flex align-center justify-end w-100">
                    <v-btn :loading="deletingBundle" @click="deleteBundle" text color="error">Delete</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { capitalize } from '@/utils'
import { createBackendErrorHandler } from '@/utils/errorMessages'
import * as lifecycleErrors from '@/modules/snapshot/errors/lifecycle'
import * as permissionsErrors from '@/utils/errors/permissions'
import * as snapshotErrors from '@/modules/snapshot/errors/snapshots'

const { getBackendErrorMessage } = createBackendErrorHandler(lifecycleErrors, permissionsErrors, snapshotErrors)

export default {
    name: 'BundleDeleteDialog',
    props: {
        bundleData: Object
    },
    computed: {
        bundleTypeName() {
            return capitalize(this.bundleData?.bundle_type_name)
        },
        bundleTypeNameLower() {
            return this.bundleTypeName.toLowerCase()
        }
    },
    data() {
        return {
            deleteBundleDialog: false,
            deletingBundle: false
        }
    },
    methods: {
        deleteBundle() {
            this.deletingBundle = true
            this.$axios
                .delete(`/bundles/${this.bundleData.bid}`)
                .then(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: `Successfully deleted ${this.bundleData.long_id}`,
                        snackBarTimeout: 5000,
                        snackBarIcon: 'check_circle'
                    })
                    this.$store.dispatch('spaceStore/fetchSpaceBundles', this.$route.params.sid)
                })
                .catch(error => {
                    const snackBarText = getBackendErrorMessage(error, `Failed to delete ${this.bundleData.long_id}`)
                    if (snackBarText) {
                        this.$store.dispatch('showSnackBar', {
                            snackBarText,
                            snackBarTimeout: 10000,
                            snackBarIcon: 'error'
                        })
                    }
                })
                .finally(() => {
                    this.deletingBundle = false
                    this.deleteBundleDialog = false
                })
        }
    }
}
</script>
